/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {

    class SuiteDetailsController {
        constructor(private dataAccessService: common.DataAccessService, private formService: common.FormService, 
        private $mdDialog:ng.material.IDialogService,) {
        }
        static $inject = ['dataAccessService', 'formService', '$mdDialog',];
        private suiteId: number;
        private dateFilter: string;
        private mainChartData: Array<Number> = [0, 0, 0];

        private mainChartColors: string[] = ["#4CAF50", "#f7464a", "#eeeeee"];
        private historyResult: entities.ISuiteHistoryResult;
        private suiteFilter: string = 'all';
        private browsers;
        private strings;

        private getHistory = (): void => {
            this.dataAccessService.getSuiteHistory(this.suiteId, this.dateFilter).then((data) => {
                this.historyResult = data;
                this.mainChartData = [data.summary.passed, data.summary.failed, data.summary.runs - data.summary.failed - data.summary.passed];
            })
        }

        private browserStackBrowsers;
        private browserStackBrowser: Number;
        private _bsBrowsers: string;
        private submitUrlBs: string;
        private submitUrl: string;

        get bsBrowsers() {
            return this._bsBrowsers;
        }
        set bsBrowsers(brs) {
            this._bsBrowsers = brs;
            this.browserStackBrowsers = JSON.parse(brs).filter((b => {
                return b.id != '';
            }))
        }

        


        //  startSuite = (formId, url) => {
        //     console.log($(formId).serialize());
        //     $.ajax({
        //         url: url,
        //         dataType: "json",
        //         type: 'POST',
        //         data: $(formId).serialize(),
        //         success: function (data) {
                  
        //             window.location.href = data.redirectUrl;
        //         }
        //     });


        // }

         private selectedBrowsers(): Array<number> {
            var browsers = [];
            angular.forEach(this.browsers, (browser) => {
                if (browser.selected === "1")
                    browsers.push(browser.id);
            })
            return browsers;
        }

        private popupBrowserAlert = () => {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .parent(angular.element(document.querySelector('.details')))
                    .clickOutsideToClose(true)
                    .title(this.strings.browserAlertTitle)
                    .textContent(this.strings.browserAlertContent)
                    .ok('OK')
            );
        };

        private startSuite($event) {
            $event.preventDefault();
            var selectedBrowsers = this.selectedBrowsers();
            if (selectedBrowsers.length == 0) {
                this.popupBrowserAlert();
                return;
            }
            this.formService.submitForm(this.submitUrl, { "browsers[]": selectedBrowsers }).then(function(data){
                //@ts-ignore
                if (data.redirectUrl)
                    //@ts-ignore
                    location.href = data.redirectUrl;
            })
            
        }

         private startSuiteBs($event) {
            $event.preventDefault();
            if (!this.browserStackBrowser){
                this.popupBrowserAlert();
                return;
            }
             this.formService.submitForm(this.submitUrlBs, { "browsers[]": this.browserStackBrowser }).then(function(data){
                 //@ts-ignore
                if (data.redirectUrl)
                    //@ts-ignore
                    location.href = data.redirectUrl;
            })
            
        }

    }

    angular.module("ultimateMonitoringApp").controller("suiteDetailsController", SuiteDetailsController);
}

